import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api, STORE_SLUG } from "../lib/api";
import { ChevronDown } from "lucide-react";

const FAQS = [
  {
    q: "How much do the tees cost?",
    a: "Front design only is $25, add the full-team Roster Back for $30, or a custom player name & number for $33. Sizes 2XL (+$2), 3XL (+$3) and 4XL (+$5) have a small upcharge. Every shirt is a Team 365 TT11 Zone Performance moisture-wicking tee.",
  },
  {
    q: "How do I get a custom player number?",
    a: "On the product page choose 'Custom Player Name + Number' as your back option ($33). You can type the player's name, number and team on the product page — or leave it blank and add it during checkout. We print exactly what you enter.",
  },
  {
    q: "How long do orders take?",
    a: "Custom name & number tees are made to order, so please allow 5–7 business days lead time before pickup or shipping. Every other shirt is kept in stock and is ready right away — you'll get an email as soon as your order is ready.",
  },
  {
    q: "What colors and designs can I choose?",
    a: "Three garment colors — Black, Grey and White — and two front designs: the War Eagles Crest or the vintage 'GRAY Volleyball 2026-2027'. The roster back lists the full Varsity, JV and Middle School teams.",
  },
  {
    q: "How do I receive my order — pickup or shipping?",
    a: "Choose free Team Pickup (Practice Pickup or Game Pickup) at checkout, or USPS shipping for a flat $8. You'll get an email the moment your order is confirmed, and again when it's ready.",
  },
  {
    q: "What payment methods do you accept?",
    a: "Secure checkout is handled by Stripe. We accept all major credit/debit cards, plus Apple Pay and Google Pay on eligible devices. We do not collect cash at pickup — all orders are paid online.",
  },
  {
    q: "Does buying support the team?",
    a: "Yes! 15% of every merchandise purchase is donated straight back to the Gray Collegiate Academy Volleyball program.",
  },
  {
    q: "Is there an order deadline?",
    a: "Shirts are printed in batches, so orders close on the posted deadline (watch the banner at the top of the site). Order early to guarantee your size and get it in the next print run.",
  },
  {
    q: "How do sizes run / what if my size is out?",
    a: "Sizes run standard unisex XS–4XL. In-stock shirts ship or are ready for pickup right away; if a size shows as unavailable it's temporarily out of stock — check back or contact us and we'll help.",
  },
];

function Item({ q, a }) {
  const [open, setOpen] = useState(false);
  return (
    <div className="border border-white/10 bg-[#141518]" data-testid="faq-item">
      <button onClick={() => setOpen(!open)} className="w-full flex items-center justify-between text-left px-5 py-4">
        <span className="font-bold text-sm sm:text-base pr-4">{q}</span>
        <ChevronDown className={`w-5 h-5 flex-shrink-0 text-[var(--gv-blue-bright)] transition-transform ${open ? "rotate-180" : ""}`} />
      </button>
      {open && <p className="px-5 pb-5 -mt-1 text-sm text-gray-300 leading-relaxed">{a}</p>}
    </div>
  );
}

export default function FAQ() {
  const [store, setStore] = useState(null);
  useEffect(() => { api.get(`/stores/${STORE_SLUG}`).then((r) => setStore(r.data)).catch(() => {}); }, []);

  return (
    <div className="max-w-3xl mx-auto px-4 sm:px-6 py-12" data-testid="faq-page">
      <p className="text-xs uppercase tracking-[0.3em] text-[var(--gv-blue-bright)] font-bold mb-2">Gray Collegiate Academy • War Eagles</p>
      <h1 className="font-display text-5xl sm:text-6xl mb-8">FAQ</h1>
      <div className="space-y-3">
        {FAQS.map((f, i) => <Item key={i} {...f} />)}
      </div>
      <div className="mt-10 border border-[var(--gv-blue)]/40 bg-[var(--gv-blue)]/5 p-6 text-center">
        <p className="text-sm text-gray-300">Still have a question? Reply to your order confirmation email and the Dad Jerzeys team will help.</p>
        <Link to="/shop/shop-all" className="inline-block mt-4 bg-[var(--gv-blue)] hover:bg-[var(--gv-blue-bright)] text-black px-8 py-3 font-bold uppercase tracking-widest text-sm transition-colors">Shop Gear</Link>
      </div>
    </div>
  );
}
